import {
  UserListingStore,
  UserListingResponse,
  USER_LISTING_RETRIEVE_START,
  USER_LISTING_RETRIEVE_SUCCESS,
  USER_LISTING_RETRIEVE_FAILED,
  USER_LISTING_SORT,
  USER_LISTING_FILTER,
  USER_LISTING_NAVPAGE
} from './types';

const defaultSort = {
  field: 'firstName',
  order: 'asc'
};

export const userListing = (
  state: UserListingStore = {
    retrieveError: null,
    currentPageIdx: 0,
    sort: defaultSort,
    filteredBy: 'ALL'
  },
  action: {
    type: string;
    payload?: unknown;
  }
): UserListingStore => {
  switch (action.type) {
    case USER_LISTING_RETRIEVE_START:
      return {
        ...state,
        retrieveLoading: true,
        retrieveError: null,
        data: null
      };
    case USER_LISTING_RETRIEVE_SUCCESS:
      return {
        ...state,
        retrieveLoading: false,
        data: action.payload as UserListingResponse
      };
    case USER_LISTING_RETRIEVE_FAILED:
      return {
        ...state,
        retrieveLoading: false,
        retrieveError: action.payload
      };
    case USER_LISTING_SORT:
      return {
        ...state,
        currentPageIdx: 0,
        sort: action.payload as { field: string; order: string }
      };
    case USER_LISTING_FILTER:
      return {
        ...state,
        currentPageIdx: 0,
        sort: defaultSort,
        filteredBy: action.payload as string
      };
    case USER_LISTING_NAVPAGE:
      return {
        ...state,
        currentPageIdx: action.payload as number
      };
    default:
      return state;
  }
};
